import { createStyles } from "@material-ui/core";
export var multiSelectFormStyles = function (theme) {
    return createStyles({
        chip: {
            margin: theme.spacing(1),
            maxWidth: "100%",
            overflow: "hidden",
            resize: "horizontal",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        },
        chips: {
            display: "flex",
            flexWrap: "wrap",
            resize: "none",
        },
    });
};
//# sourceMappingURL=MultiSelectForm.style.js.map